import "./index.css";
import React from "react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";
import App from "./App";
import { ThemeProvider } from "./context/ThemeContext";
import "./i18n";

// import {store } from './redux/store/store'; // Import your Redux store
const store = configureStore({ reducer: rootReducer, devTools: true });

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </Provider>
  </StrictMode>,
);
